var _circle, _circle2, _circle3, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoModalPosteFr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 36,
    fill: "#EEEEEE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 23,
    fill: "#FFCB05"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.8018 42.3198H42.2241L28.7414 50.8923C28.5763 51.0242 28.7144 51.2776 28.9109 51.2244L58.9083 43.0627C59.0449 43.0244 59.1814 42.8946 59.1814 42.6965C59.1814 42.4709 58.9924 42.3198 58.8018 42.3198Z",
    fill: "#2B39FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5773 37.9815L42.2204 41.0172H52.3981L53.2412 39.5483C53.7483 38.6669 53.1362 37.6111 52.2135 37.6111H35.6463C35.4227 37.6111 35.3672 37.8879 35.5743 37.9836L35.5773 37.9815Z",
    fill: "#2B39FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5752 49.413L48.8804 47.1375L33.8359 51.231L44.7187 51.0265C45.7749 51.0074 47.0111 50.3966 47.5752 49.4109V49.413Z",
    fill: "#2B39FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoModalPosteFr);
export default __webpack_public_path__ + "static/media/logoModalPosteFR.ffcd3ce6571d4e0129a12ed71c12e720.svg";
export { ForwardRef as ReactComponent };